import { EventEmitter, Injectable } from '@angular/core';
import { DpModalService, HeaderAction } from '@docpath/webcomponents';
import { faMagnifyingGlass, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import { Alias } from '../../../alias/models/alias';
import { AliasHttpService } from '../../../alias/services/alias-http.service';
import { AlertRule } from '../../models/alert-rule';
import { AlertRulesService } from '../../services/alert-rules.service';
import { AlertRulesFormService } from '../../services/alert-rules-form.service';
import { AlertRulesHttpService } from '../../services/alert-rules-http.service';

@Injectable({
    providedIn: 'root'
})
export class AlertRulesHeaderService {

    aliasOptionsLoaded: EventEmitter<Alias[]> = new EventEmitter();
    private readonly i18nPrefix = 'alert-rules-config';

    constructor(
        private readonly alertRulesFormsService: AlertRulesFormService,
        private readonly aliasHttpService: AliasHttpService,
        private readonly alertRulesHttpService: AlertRulesHttpService,
        private readonly modalService: DpModalService,
        private readonly alertRulesService: AlertRulesService
    ){}

    getRightActions(alias: Alias[]): HeaderAction[] {

        const rightActions = [this.initSearchAction()];

        rightActions.push(this.initNewAlertRuleAction(alias));

        return rightActions;

    }

    getLeftActions(selectedAlertRules: AlertRule[], alias: Alias[]): HeaderAction[] {

        const actions = [];

        if (selectedAlertRules.length === 1) {
            const alertRuleSelected = selectedAlertRules[0];
            actions.push(this.initEditAction(alertRuleSelected, alias));
        }
        if (selectedAlertRules.length > 0) {
            actions.push(this.initDeleteAction(selectedAlertRules));
        }

        return actions;

    }

    private initSearchAction(): HeaderAction {

        const action = new HeaderAction(`${this.i18nPrefix}.header.search.label`, { cssClass: 'btn btn-dpsecondary' });
        action.tooltip = `${this.i18nPrefix}.header.search.tooltip`;
        action.icon = faMagnifyingGlass;

        return action;

    }

    private initNewAlertRuleAction(alias: Alias[]): HeaderAction {

        const newAlertRuleAction = new HeaderAction(`${this.i18nPrefix}.header.new-alert-rule.label`);

        newAlertRuleAction.icon = faPlusCircle;
        newAlertRuleAction.tooltip = `${this.i18nPrefix}.header.new-alert-rule.tooltip`;
        newAlertRuleAction.action = () => this.alertRulesFormsService.openCreationAlertRuleForm(alias);

        return newAlertRuleAction;

    }

    private initDeleteAction(alertRules: AlertRule[]): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.delete.label`);

        action.tooltip = `${this.i18nPrefix}.header.delete.tooltip`;
        action.action = () => this.deleteAlertRules(alertRules);

        return action;
    }

    getSearchAction(actions: HeaderAction[]): HeaderAction {
        return actions[0];
    }

    loadAliasOptions(): void {

        this.aliasHttpService.getAllAlias(result => {
            this.aliasOptionsLoaded.emit(result);
        });
    }

    private deleteAlertRules(alertRules: AlertRule[]): void {

        const alertRulesIds = alertRules.map(alertRuleElement => alertRuleElement.id),
            modal = this.modalService.openQuestion(`${this.i18nPrefix}.modal.delete-question`);

        modal.componentInstance.accepted.subscribe(() => {
            this.deleteAlertRuleRequest(alertRulesIds);
        });

    }

    private deleteAlertRuleRequest(alertRulesIds: number[]): void {

        this.alertRulesHttpService.deleteAlertRules(alertRulesIds, () => {
            this.alertRulesService.notifyAlertRuleChange();
        });

    }

    private initEditAction(alertRule: AlertRule, alias: Alias[]): HeaderAction {

        const action = new HeaderAction(`${this.i18nPrefix}.header.edit.label`);

        action.tooltip = `${this.i18nPrefix}.header.edit.tooltip`;
        action.action = () => this.alertRulesFormsService.openEditAlertRuleForm(alertRule, alias);

        return action;

    }

}